import { render, staticRenderFns } from "./Flipped.vue?vue&type=template&id=1d0b2226&"
import script from "./Flipped.vue?vue&type=script&lang=js&"
export * from "./Flipped.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports